import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m21.76 5.01-2.79-2.8-.22-.21h-6.32c-1.52 0-2.75 1.22-2.75 2.75v2.06H4.75C3.23 6.81 2 8.04 2 9.56v9.67c0 1.52 1.23 2.75 2.75 2.75h6.79c1.52 0 2.76-1.24 2.76-2.76v-2.06h4.92a2.75 2.75 0 0 0 2.76-2.75V5.22l-.22-.21Zm-3.33-1.22 1.94 1.94h-1.94V3.79ZM12.8 19.23c0 .69-.56 1.25-1.25 1.25h-6.8c-.69 0-1.25-.56-1.25-1.25V9.56c0-.69.56-1.25 1.25-1.25h4.12l.81-.01v6.11c0 1.53 1.23 2.75 2.75 2.75h.37v2.07Zm7.68-4.82c0 .69-.56 1.25-1.25 1.25h-6.8c-.69 0-1.25-.56-1.25-1.25V4.75c0-.7.56-1.25 1.25-1.25h4.5v2.98c0 .42.33.75.75.75h2.8v7.18Z" fill="#193446" />' }
  })
);